// 2020-06-27export { DescargaChartComponent } from './descarga-chart.component';